import React from 'react';

const EventsCalendar = () => {
  return (
    <iframe
      title='eventsCalendar'
      src='https://calendar.google.com/calendar/embed?src=lv5b95c37926e08bbs8jj20n38%40group.calendar.google.com&ctz=America%2FLos_Angeles'
      width='100%'
      height='600px'
      frameBorder='0'
    ></iframe>
  );
};

export default EventsCalendar;
